module.exports = __webpack_public_path__ + "static/media/vaishnavi_shambharkar.55f00272.png";